import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as styles from './styles/styles.module.scss';

const TabBar = ({ variant, tabs, handler, className, activeItemKey, loading }) => {
  const renderLink = item => {
    const { inactiveString, activeString, itemKey } = item;
    const action = handler(itemKey);
    const isActive = itemKey === activeItemKey;
    return (
      <div
        key={itemKey}
        tabIndex="0"
        role="tab"
        className={classNames(styles.tab, styles[variant], isActive ? styles.active : '')}
        onClick={action}
        onKeyDown={action}
      >
        {isActive && !loading ? activeString : inactiveString}
      </div>
    );
  };
  const renderedTabs = tabs.map(item => renderLink(item));
  return <div className={`${styles.tabBar} ${styles[variant]} ${className}`}>{renderedTabs}</div>;
};

TabBar.defaultProps = {
  handler: () => {},
  className: '',
  activeItemKey: ''
};

TabBar.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.object).isRequired,
  handler: PropTypes.func,
  className: PropTypes.string,
  activeItemKey: PropTypes.string
};

export default TabBar;
